module.exports = __webpack_public_path__ + "img/icon-logout-white.4171e3af.svg";